module.exports = __webpack_public_path__ + "img/el_telar_de_antigua.3f9cc0b1.jpeg";